import React from 'react';
import './DatasetButton.scss';
import axios from 'axios'
import fileDownload from 'js-file-download'
import SystemConfiguration from 'settings/SystemConfiguration';
import Images from 'constants/Images';
import * as THREE from 'three';
import { Material } from 'three';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader } from "@react-three/fiber";
import $ from "jquery";

function DatasetButton(props) {

    function handleClick() {
        var menu_panel = $('#leftpanel_main')
        var rmenu_panel = $('#rightpanel_menu')

        if (menu_panel.css("visibility") == "hidden") {
            menu_panel.css("visibility", "visible")
            rmenu_panel.css("visibility", "hidden")
        }
        else {
            menu_panel.css("visibility", "hidden")
        }
    }

    const button_style = {
        visibility: window.innerWidth > 1200 ? "hidden" : "visible"
    }

    return (
        <img style={button_style} id="datasetbutton" src={process.env.PUBLIC_URL + Images.button_data} onClick={() => handleClick()}/>
    );

}

export default DatasetButton;